import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCourseById } from "../http/academyAPI";
import { Typography, Container, Grid, CircularProgress } from "@mui/material";
import Lesson from "../components/Lesson";

const CourseDetails = () => {
  const { id: courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const data = await getCourseById(courseId);
        setCourse(data);
      } catch {
        setError("Ошибка при загрузке курса");
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, [courseId]);

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Container maxWidth="lg" sx={{ padding: 4 }}>
      <Typography
        variant="h5"
        component="h1"
        gutterBottom
        sx={{ paddingBottom: "40px" }}
      >
        {course.name || ""}
      </Typography>
      <Grid container spacing={4}>
        {course.lessons.map((lesson) => (
          <Grid item xs={12} sm={6} md={4} key={lesson.id}>
            <Lesson lesson={lesson} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CourseDetails;
